import { Component, h } from 'preact';
import { Row, Column } from '../../../common/Layout/Layout';
import { WithStyles, withStyles } from '../../../style';
import Icon from '../../../common/Icon/Icon';
import Notification, { Severity } from '../Notification/Notification';
import * as appStyles from '../../../assets/global.scss';
import { Properties } from '../../../common';
import { Expander } from '../Expander/Expander';
import { FinText } from '../../../i18n';

const AM_NOTIFICATION_CONTENT_ID = 'amNotificationContent';

export interface AmNotificationProps extends Properties {
  onExpand: (notificationName: string, expandStatus: boolean) => void;
}
interface AmNotificationState {
  expanded: boolean;
}

type EffectiveProps = AmNotificationProps & WithStyles;

@withStyles(appStyles)
export default class AmNotification extends Component<AmNotificationProps, AmNotificationState> {
  state = {
    expanded: false,
  };

  toggleExpand = (): void => {
    const expanded = !this.state.expanded;

    this.props.onExpand('amNotification', expanded);
    this.setState(() => ({ expanded }));
  };

  render({ tx }: EffectiveProps, { expanded }: AmNotificationState): h.JSX.Element {
    return (
      <Notification class={tx('font-body-1 flex--align-start')} open severity={Severity.INFO} expanded={expanded}>
        <Row vCenter={false} hCenter={false}>
          <Column vCenter={false} hCenter={false}>
            <p class={tx('notificationTeaser', 'flex flex--column flex--center flex--align-start')}>
              <FinText id="aurinkomatkat.notification.teaser" />
            </p>
            {expanded && (
              <p id={AM_NOTIFICATION_CONTENT_ID} class={tx('ps-medium-y', { expanded })}>
                <FinText id="aurinkomatkat.notification.content" />
              </p>
            )}
          </Column>
          <Expander
            class="ms-small-l flex--self-start"
            expanded={expanded}
            onExpand={this.toggleExpand}
            ariaControls={AM_NOTIFICATION_CONTENT_ID}
            ariaLabel={<FinText id={`aurinkomatkat.notification.${expanded ? 'showLess' : 'showMore'}`} />}
            data-test-am-notification-expander
          >
            <Icon
              iconName="chevron-down"
              class={tx('ir-small focus-inset', 'link-hover overflow-hidden', {
                expanded,
                'rotate-active': expanded,
              })}
            />
          </Expander>
        </Row>
      </Notification>
    );
  }
}
